import { Theme, tokens, webLightTheme } from "@fluentui/react-components";

type DolphinTheme = Theme & {
    colorLightBlue: string;
    colorLightBlue80: string;
    colorLightBlue60: string;
    colorLightBlue40: string;
    colorLightBlue20: string;
    colorDarkBlue: string;
    colorDarkBlue80: string;
    colorDarkBlue60: string;
    colorDarkBlue40: string;
    colorDarkBlue20: string;
    colorTomatoRed: string;
    colorTomatoRed80: string;
    colorTomatoRed60: string;
    colorTomatoRed40: string;
    colorTomatoRed20: string;
    colorMintGreen: string;
    colorMintGreen80: string;
    colorMintGreen60: string;
    colorMintGreen40: string;
    colorMintGreen20: string;
    colorPeachOrange: string;
    colorPeachOrange80: string;
    colorPeachOrange60: string;
    colorPeachOrange40: string;
    colorPeachOrange20: string;
    colorSunflowerYellow: string;
    colorSunflowerYellow80: string;
    colorSunflowerYellow60: string;
    colorSunflowerYellow40: string;
    colorSunflowerYellow20: string;
    colorSkyLavender: string;
    colorSkyLavender80: string;
    colorSkyLavender60: string;
    colorSkyLavender40: string;
    colorSkyLavender20: string;
    colorCreamWhite: string;
};

const theme: DolphinTheme = {
    ...webLightTheme,
    fontFamilyBase: "'Golos Text', sans-serif",
    colorLightBlue: "rgba(6, 131, 163, 1)",
    colorLightBlue80: "rgba(6, 131, 163, 0.8)",
    colorLightBlue60: "rgba(6, 131, 163, 0.6)",
    colorLightBlue40: "rgba(6, 131, 163, 0.4)",
    colorLightBlue20: "rgba(6, 131, 163, 0.2)",
    colorDarkBlue: "rgba(0, 57, 76, 1)",
    colorDarkBlue80: "rgba(0, 57, 76, 0.8)",
    colorDarkBlue60: "rgba(0, 57, 76, 0.6)",
    colorDarkBlue40: "rgba(0, 57, 76, 0.4)",
    colorDarkBlue20: "rgba(0, 57, 76, 0.2)",
    colorTomatoRed: "rgba(255, 76, 76, 1)",
    colorTomatoRed80: "rgba(255, 76, 76, 0.8)",
    colorTomatoRed60: "rgba(255, 76, 76, 0.6)",
    colorTomatoRed40: "rgba(255, 76, 76, 0.4)",
    colorTomatoRed20: "rgba(255, 76, 76, 0.2)",
    colorMintGreen: "rgba(61, 220, 151,1)",
    colorMintGreen80: "rgba(61, 220, 151, 0.8)",
    colorMintGreen60: "rgba(61, 220, 151, 0.6)",
    colorMintGreen40: "rgba(61, 220, 151, 0.4)",
    colorMintGreen20: "rgba(61, 220, 151, 0.2)",
    colorPeachOrange: "rgba(255, 183, 112, 1)",
    colorPeachOrange80: "rgba(255, 183, 112, 0.8)",
    colorPeachOrange60: "rgba(255, 183, 112, 0.6)",
    colorPeachOrange40: "rgba(255, 183, 112, 0.4)",
    colorPeachOrange20: "rgba(255, 183, 112, 0.2)",
    colorSunflowerYellow: "rgba(255, 217, 61, 1)",
    colorSunflowerYellow80: "rgba(255, 217, 61, 0.8)",
    colorSunflowerYellow60: "rgba(255, 217, 61, 0.6)",
    colorSunflowerYellow40: "rgba(255, 217, 61, 0.4)",
    colorSunflowerYellow20: "rgba(255, 217, 61, 0.2)",
    colorSkyLavender: "rgba(214, 198,255, 1)",
    colorSkyLavender80: "rgba(214, 198, 255, 0.8)",
    colorSkyLavender60: "rgba(214, 198, 255, 0.6)",
    colorSkyLavender40: "rgba(214, 198, 255, 0.4)",
    colorSkyLavender20: "rgba(214, 198, 255, 0.2)",
    colorCreamWhite: "rgb(255, 247, 235)"
};

theme.colorBrandBackground = theme.colorLightBlue;
theme.colorBrandBackgroundHover = theme.colorLightBlue80;
theme.colorBrandBackgroundPressed = theme.colorLightBlue60;

export const dolphinTheme = theme;

export const dolphinTokens: Record<keyof DolphinTheme, string> = {
    ...tokens,
    colorLightBlue: "var(--colorLightBlue)",
    colorLightBlue80: "var(--colorLightBlue80)",
    colorLightBlue60: "var(--colorLightBlue60)",
    colorLightBlue40: "var(--colorLightBlue40)",
    colorLightBlue20: "var(--colorLightBlue20)",
    colorDarkBlue: "var(--colorDarkBlue)",
    colorDarkBlue80: "var(--colorDarkBlue80)",
    colorDarkBlue60: "var(--colorDarkBlue60)",
    colorDarkBlue40: "var(--colorDarkBlue40)",
    colorDarkBlue20: "var(--colorDarkBlue20)",
    colorTomatoRed: "var(--colorTomatoRed)",
    colorTomatoRed80: "var(--colorTomatoRed80)",
    colorTomatoRed60: "var(--colorTomatoRed60)",
    colorTomatoRed40: "var(--colorTomatoRed40)",
    colorTomatoRed20: "var(--colorTomatoRed20)",
    colorMintGreen: "var(--colorMintGreen)",
    colorMintGreen80: "var(--colorMintGreen80)",
    colorMintGreen60: "var(--colorMintGreen60)",
    colorMintGreen40: "var(--colorMintGreen40)",
    colorMintGreen20: "var(--colorMintGreen20)",
    colorPeachOrange: "var(--colorPeachOrange)",
    colorPeachOrange80: "var(--colorPeachOrange80)",
    colorPeachOrange60: "var(--colorPeachOrange60)",
    colorPeachOrange40: "var(--colorPeachOrange40)",
    colorPeachOrange20: "var(--colorPeachOrange20)",
    colorSunflowerYellow: "var(--colorSunflowerYellow)",
    colorSunflowerYellow80: "var(--colorSunflowerYellow80)",
    colorSunflowerYellow60: "var(--colorSunflowerYellow60)",
    colorSunflowerYellow40: "var(--colorSunflowerYellow40)",
    colorSunflowerYellow20: "var(--colorSunflowerYellow20)",
    colorSkyLavender: "var(--colorSkyLavender)",
    colorSkyLavender80: "var(--colorSkyLavender80)",
    colorSkyLavender60: "var(--colorSkyLavender60)",
    colorSkyLavender40: "var(--colorSkyLavender40)",
    colorSkyLavender20: "var(--colorSkyLavender20)",
    colorCreamWhite: "var(--colorCreamWhite)"
};